// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Logo_dropzone__150tU","active":"Logo_active__23wUE","logo":"Logo_logo__28Byj"};